import { RouteObject } from "react-router-dom";
import { WebsiteLayout } from "../components/layouts/websiteLayout";
import { Error404Page } from "../pages/error/error404Page";
import { LandingPage } from "../pages/website/landing-page/landingPage";

export const websiteRoutes: RouteObject[] = [
  {
    path: "/",
    errorElement: <Error404Page />,
    children: [
      {
        index: true,
        path: "",
        element: (
          <WebsiteLayout>
            <LandingPage />
          </WebsiteLayout>
        ),
      },
    ],
  },
];
